import {
  Box,
  IconButton,
  LightMode,
  List,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Portal,
} from '@chakra-ui/react'

import { fetchNotifications } from '../../services/NotificationService'
import { useAppStore } from '../../store/appStore/appStore'
import { NotificationIcon } from './NotificationIcon'
import { NotificationItem } from './NotificationItem'
import { NotificationsHeader } from './NotificationsHeader'

export type QueryExport = {
  id: string
  createdDate: string
  updatedDate: string
  fileId: string | null
  fileName: string | null
  status: 'RUNNING' | 'SUCCESS' | 'ERROR' | 'QUEUED'
  message: string | null
  queryDefinitionId: string
  retrievedRowCount: number | null
  totalRowCount: number | null
  estimatedDurationMs: number | null
  queryStartTime: string | null
}

export type NotificationItemResponse = Awaited<
  ReturnType<typeof fetchNotifications>
>[number]

export const NotificationsMenu = () => {
  const { notifications, markAllAsRead, markErrorsAsRead } =
    useAppStore().notifications

  const unreadCount =
    notifications.filter(
      notification =>
        !notification?.isRead && notification.category !== 'PENDING',
    ).length || 0

  return (
    <Popover
      variant="rounded"
      placement="bottom-end"
      onClose={() => {
        markErrorsAsRead()
      }}
    >
      {({ isOpen }) => (
        <>
          <PopoverTrigger>
            <IconButton
              isActive={isOpen}
              _active={{
                backgroundColor: 'presets.turquoise.10',
              }}
              _dark={{
                _active: { bg: 'presets.neutral.40' },
              }}
              aria-label="notifications"
              icon={<NotificationIcon count={unreadCount} />}
              minWidth="none"
            />
          </PopoverTrigger>
          <Portal>
            <LightMode>
              <PopoverContent
                overflow="auto"
                height="516px"
                width="454px"
                boxShadow="0px 6px 20px 0px rgba(0, 0, 0, 0.14)"
                borderRadius="5px 0px 0px 5px"
              >
                <Box display="flex" flexDirection="column">
                  <NotificationsHeader
                    unreadCounter={unreadCount}
                    dismissNotifications={markAllAsRead}
                  />
                  <List padding="0" margin="0" overflow="auto">
                    {notifications.map(notification => (
                      <NotificationItem
                        key={notification.id}
                        notification={notification}
                      />
                    ))}
                  </List>
                </Box>
              </PopoverContent>
            </LightMode>
          </Portal>
        </>
      )}
    </Popover>
  )
}
